import { useEffect, useState } from 'react';

const DEFAULT_WINDOW_MS = 6_000;

/**
 * Returns true for `windowMs` after `lastChangeAt`, then false — used to
 * flash a counter on the public board when its called token changes.
 */
export function useBlinkWindow(
  lastChangeAt: number | undefined,
  windowMs = DEFAULT_WINDOW_MS,
): boolean {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!lastChangeAt) return;
    const remaining = lastChangeAt + windowMs - Date.now();
    if (remaining <= 0) return;
    const id = setTimeout(() => setNow(Date.now()), remaining);
    return () => clearTimeout(id);
  }, [lastChangeAt, windowMs]);
  if (!lastChangeAt) return false;
  return now - lastChangeAt < windowMs;
}
